import React from "react";

const VideoThumbnail = React.forwardRef(({ thumbnail, onClick }, ref) => (
    <img
        ref={ref}
        src={thumbnail}
        alt="Video Thumbnail"
        className="video-thumbnail video-img"
        onClick={onClick}
        onContextMenu={e => e.preventDefault()}
    />
));

VideoThumbnail.displayName = "VideoThumbnail";

export default VideoThumbnail;
